<template>
  <div>
    <section class="success-section">
      <div class="header">
        <v-icon size="35" class="icon" color="#52C41A">{{
          mdiCheckCircleOutline
        }}</v-icon>
        <div class="d-flex flex-column">
          <span class="title">Запрос на смену нотариального округа по заявлению направлен в Единую информационную систему нотариата</span>
        </div>
      </div>
    </section>
    <div class="mt-10">
      <template>
        <v-btn
          depressed
          color="primary"
          class="button-base"
          @click="goToStatementsList"
          >Перейти в Мои заявления
        </v-btn>
      </template>
    </div>
  </div>
</template>

<script>
import { mdiCheckCircleOutline } from '@mdi/js';
import { RouteName } from '@/router';

export default {
  name: 'AltDistrictSuccess',
  data() {
    return {
      mdiCheckCircleOutline,
    };
  },
  methods: {
    goToStatementsList() {
      this.$router.push({
        name: RouteName.STATEMENTS,
        params: {},
      });
    },
  },
};
</script>

<style scoped lang="scss">
.success-section {
  border: 1px solid $color-dark-grey;
  padding: 20px 100px 20px 40px;
  width: fit-content;

  &--history {
    border: none;
    padding: 0;
    width: 100%;
  }

  & .title {
    font-weight: 600;
    color: $color-base;
    font-size: $font-size-middle-level-2 !important;
  }

  & .header {
    display: flex;
    flex-direction: row;
    align-items: center;

    & .icon {
      margin-right: 10px;
    }

    & .sub-title {
      color: $color-base;
      font-size: $font-size-small !important;
    }
  }
}
</style>
